export default __webpack_public_path__ + "static/media/logo3.dcd34681.png";